import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Default to dark mode, or use localStorage if available
  const [theme, setTheme] = useState(() => {
    const stored = localStorage.getItem('theme');
    return stored ? stored : 'dark';
  });

  const [compactDatagrid, setCompactDatagrid] = useState(() => {
    return localStorage.getItem('compactDatagrid') === 'true';
  });

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  useEffect(() => {
    const density = compactDatagrid ? 'compact' : 'comfortable';
    document.body.setAttribute('data-datagrid-density', density);
    document.documentElement.setAttribute('data-datagrid-density', density);
    localStorage.setItem('compactDatagrid', String(compactDatagrid));
  }, [compactDatagrid]);

  const toggleTheme = () => {
    setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  const toggleCompactDatagrid = () => {
    setCompactDatagrid((prev) => !prev);
  };

  return (
    <ThemeContext.Provider
      value={{ theme, toggleTheme, compactDatagrid, toggleCompactDatagrid }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
